import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import router from "@/router/index";
import { installUi } from "@/utils/ui";

Vue.config.productionTip = false
Vue.use(installUi);
Vue.prototype.$axios = axios;
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
